// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generalContainer_iaZN5 {
  height: fit-content;
  position: relative;
}
.labelGeneral_CGDMD {
  display: flex;
  padding: 11px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-bottom: 1px solid var(--eb-border);
  input {
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    color: var(--_807d7d-color);
    min-height: 21px;
    background-color: var(--f4-background);
    border-radius: 5px;
    box-sizing: border-box;
    width: 100%;
    padding: 12px;
  }
  .row_zWe5H {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;


.typePlan_zfp26{
  text-transform: capitalize;
}
    p {
      margin: 0;
    }
    .colors_qSkCG {
      display: flex;
      align-items: center;
      gap: 10px;
      .color_kGLCA {
        cursor: pointer;
        width: 42px;
        height: 24px;
        flex-shrink: 0;
        border-radius: 9999px;
      }
    }
    >div{
      cursor: default;
    }
    .currencyDropdown_V4q6M{
      cursor: pointer;
    }
  }

  .editButton_Agx54{
    opacity: 0;
    display: flex;
    justify-content: end;
  }

  &:hover{
    .editButton_Agx54{
      opacity: 1;
    }
  }
}
.bg_yVJAD {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: var(--_3c3a3a-color);
}
.newCurrencyPopup_a48zo {
  position: fixed;
  background-color: var(--white-background);
  padding: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 70vh;
  overflow-y: scroll;
  .dropdownOption_f9hwO {
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    color: var(--_9c9d9f-color);
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    transition: background-color 0.2s;
    -webkit-transition: background-color 0.2s;
    -moz-transition: background-color 0.2s;
    -ms-transition: background-color 0.2s;
    -o-transition: background-color 0.2s;

    &:hover {
      background-color: var(--ececf1-background);
    }
  }
}

.deleteChatsContainer_nsF0E {
  width: 80%;
  background-color: var(--white-background);
  margin: 0 auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  p {
    margin: 0;
    color: var(--_38343d-color);
  }
  .password_AKoHS {
    display: flex;
    align-items: center;
    span,
    > div {
      flex: 1 1;
    }
    > div {
      input {
        border: none;
        outline: none;
        font-size: 14px;
        font-weight: 400;
        color: var(--_807d7d-color);
        min-height: 21px;
        background-color: var(--f4-background);
        border-radius: 5px;
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
      }
      span {
        color: var(--b40e1b-color);
        font-size: 13px;
      }
    }
  }
}



`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/General.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yCAAyC;EACzC;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;;;AAGf;EACE,0BAA0B;AAC5B;IACI;MACE,SAAS;IACX;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT;QACE,eAAe;QACf,WAAW;QACX,YAAY;QACZ,cAAc;QACd,qBAAqB;MACvB;IACF;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF;;EAEA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE;MACE,UAAU;IACZ;EACF;AACF;AACA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,MAAM;EACN,OAAO;EACP,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iCAAiC;IACjC,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;;IAEpC;MACE,0CAA0C;IAC5C;EACF;AACF;;AAEA;EACE,UAAU;EACV,yCAAyC;EACzC,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;IACE,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB;;MAEE,SAAO;IACT;IACA;MACE;QACE,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,2BAA2B;QAC3B,gBAAgB;QAChB,sCAAsC;QACtC,kBAAkB;QAClB,sBAAsB;QACtB,WAAW;QACX,aAAa;MACf;MACA;QACE,0BAA0B;QAC1B,eAAe;MACjB;IACF;EACF;AACF","sourcesContent":[".generalContainer {\n  height: fit-content;\n  position: relative;\n}\n.labelGeneral {\n  display: flex;\n  padding: 11px 0px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  border-bottom: 1px solid var(--eb-border);\n  input {\n    border: none;\n    outline: none;\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--_807d7d-color);\n    min-height: 21px;\n    background-color: var(--f4-background);\n    border-radius: 5px;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 12px;\n  }\n  .row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n\n\n.typePlan{\n  text-transform: capitalize;\n}\n    p {\n      margin: 0;\n    }\n    .colors {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      .color {\n        cursor: pointer;\n        width: 42px;\n        height: 24px;\n        flex-shrink: 0;\n        border-radius: 9999px;\n      }\n    }\n    >div{\n      cursor: default;\n    }\n    .currencyDropdown{\n      cursor: pointer;\n    }\n  }\n\n  .editButton{\n    opacity: 0;\n    display: flex;\n    justify-content: end;\n  }\n\n  &:hover{\n    .editButton{\n      opacity: 1;\n    }\n  }\n}\n.bg {\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  background-color: var(--_3c3a3a-color);\n}\n.newCurrencyPopup {\n  position: fixed;\n  background-color: var(--white-background);\n  padding: 10px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 70vh;\n  overflow-y: scroll;\n  .dropdownOption {\n    padding: 8px 12px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--_9c9d9f-color);\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    -webkit-transition: background-color 0.2s;\n    -moz-transition: background-color 0.2s;\n    -ms-transition: background-color 0.2s;\n    -o-transition: background-color 0.2s;\n\n    &:hover {\n      background-color: var(--ececf1-background);\n    }\n  }\n}\n\n.deleteChatsContainer {\n  width: 80%;\n  background-color: var(--white-background);\n  margin: 0 auto;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  p {\n    margin: 0;\n    color: var(--_38343d-color);\n  }\n  .password {\n    display: flex;\n    align-items: center;\n    span,\n    > div {\n      flex: 1;\n    }\n    > div {\n      input {\n        border: none;\n        outline: none;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--_807d7d-color);\n        min-height: 21px;\n        background-color: var(--f4-background);\n        border-radius: 5px;\n        box-sizing: border-box;\n        width: 100%;\n        padding: 12px;\n      }\n      span {\n        color: var(--b40e1b-color);\n        font-size: 13px;\n      }\n    }\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"generalContainer": `generalContainer_iaZN5`,
	"labelGeneral": `labelGeneral_CGDMD`,
	"row": `row_zWe5H`,
	"typePlan": `typePlan_zfp26`,
	"colors": `colors_qSkCG`,
	"color": `color_kGLCA`,
	"currencyDropdown": `currencyDropdown_V4q6M`,
	"editButton": `editButton_Agx54`,
	"bg": `bg_yVJAD`,
	"newCurrencyPopup": `newCurrencyPopup_a48zo`,
	"dropdownOption": `dropdownOption_f9hwO`,
	"deleteChatsContainer": `deleteChatsContainer_nsF0E`,
	"password": `password_AKoHS`
};
export default ___CSS_LOADER_EXPORT___;
